import { Avatar } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SAvatar = styled(Avatar)``;
